import {MenuItem, Select, Table, TableBody, TableCell, TableRow, TextField} from "@mui/material";
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import React from "react";
import {useStores} from "../../../../Hooks";

export const SelectPeriodicValues = ({dayValue, monthValue, weekValue, frequency, periodType, setWeekValue,
                                         setMonthValue ,setDayValue, setFrequency, setPeriodType }) => {
    const {generalStore} = useStores();

    const periodTypeKeys = ['Day', 'Week', 'Month', 'Year'];
    const periodTypeKeysPlural = ['Days', 'Weeks', 'Months', 'Years']
    const weekDayAbbreviations = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'];
    const monthValueKeys = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    const longMonths = new Set([0, 2, 4, 6, 7, 9, 11]);

    const resetValues = () => {
        setWeekValue(1);
        setDayValue(1);
        setMonthValue(1);
    }

    const handleSelectFrequency = e => {
        let updatedValue = Number(e.target.value) || 0;
        if (updatedValue < 1) {
            updatedValue = "";
        } else if (updatedValue > 999) {
            updatedValue = 999;
        }
        setFrequency(updatedValue);
    }

    const handleChangePeriodType = e => {
        const updatedValue = e.target.value;
        if (periodType !== updatedValue) {
            resetValues();
        }
        setPeriodType(updatedValue);
    }

    const selectDayValue = (newValue, currentMonthValue) => {
        let updatedValue = Number(newValue);
        if (newValue < 1) {
            updatedValue = ""
        } else if (longMonths.has(currentMonthValue) && newValue >= 31) {
            updatedValue = 31;
        } else if (currentMonthValue !== 1 && newValue > 30) {
            updatedValue = 30;
        } else if (currentMonthValue === 1 && newValue > 28) {
            updatedValue = 28;
        }
        setDayValue(updatedValue);
    }

    const handleChangeMonthValue = e => {
        const updatedValue = e.target.value;
        setMonthValue(updatedValue);
        selectDayValue(dayValue, updatedValue);
    }

    const renderYearValueOption = () => {
        return (
            <>
                <div className='select-and-input-row year-value'>
                    <span className="mt-1">{generalStore.translate('on')}</span>
                    <TextField
                        className='number-input'
                        variant='outlined'
                        onChange={(e) => selectDayValue(e.target.value, monthValue)}
                        value={dayValue}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <Select
                        className='select-input'
                        value={monthValue}
                        variant='outlined'
                        onChange={handleChangeMonthValue}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    '& .MuiMenuItem-root': {
                                        color: 'var(--main-normal-color)',
                                    },
                                },
                            },
                        }}
                    >
                        {monthValueKeys.map((monthKey, key) =>
                            <MenuItem
                                value={key}
                                key={monthKey}
                            >
                                {generalStore.translate(monthKey)}
                            </MenuItem>
                        )}
                    </Select>
                </div>
                {renderMonthValueOption()}
            </>
        )
    }

    const renderMonthValueOption = () => {
        return (
            <Table className='select-month-value'>
                <TableBody>
                    {[0, 1, 2, 3, 4].map(weekKey => {
                        if (!(weekKey === 4 && Number(monthValue) === 1)) {
                            return (
                                <TableRow key={weekKey}>
                                    {[1, 2, 3, 4, 5, 6, 7].map(currentKey => {
                                        const dayKey = currentKey + 7 * weekKey;
                                        const dayMax = longMonths.has(Number(monthValue)) ? 32 : 31
                                        return (
                                            <TableCell
                                                className={`select-value-cell${dayKey === Number(dayValue) ? ' selected' : ''}`}
                                                key={dayKey}
                                                onClick={() => dayKey < dayMax && setDayValue(dayKey)}
                                                hidden={dayKey >= dayMax}
                                            >
                                                {dayKey}
                                            </TableCell>
                                        )
                                    })}
                                </TableRow>
                            )
                        } else return null
                    })}
                </TableBody>
            </Table>
        )
    }

    const renderWeekValueOption = () => {
        return (
            <Table className='select-week-value'>
                <TableBody>
                    <TableRow>
                        {weekDayAbbreviations.map((weekDayAbbr, key) =>
                            <TableCell
                                className={`select-value-cell${key === weekValue ? ' selected' : ''}`}
                                key={weekDayAbbr}
                                onClick={() => setWeekValue(key)}
                            >
                                {generalStore.translate(weekDayAbbr)}
                            </TableCell>
                        )}
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    return (
        <div className="select-periodic-values flex flex-col">
            <div className='select-and-input-row'>
                <span className="mt-1">{generalStore.translate('every')}</span>
                <TextField
                    className='number-input'
                    variant='outlined'
                    onChange={handleSelectFrequency}
                    value={frequency}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
                <Select
                    className='select-input'
                    value={periodType}
                    variant='outlined'
                    onChange={handleChangePeriodType}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                '& .MuiMenuItem-root': {
                                    color: 'var(--main-normal-color)',
                                },
                            },
                        },
                    }}
                >
                    {[0, 1, 2, 3].map(periodKey =>
                        <MenuItem
                            key={periodKey}
                            value={periodKey}
                        >
                            {frequency <= 1 ? periodTypeKeys[periodKey] : periodTypeKeysPlural[periodKey]}
                        </MenuItem>
                    )}
                </Select>
            </div>
            <div className='select-period-value-container'>
                <ConditionalComponent if={periodType === 1}>
                    {renderWeekValueOption()}
                </ConditionalComponent>
                <ConditionalComponent if={periodType === 2}>
                    {renderMonthValueOption()}
                </ConditionalComponent>
                <ConditionalComponent if={periodType === 3}>
                    {renderYearValueOption()}
                </ConditionalComponent>
            </div>
        </div>
    )
}